import { AlertTriangle, Inbox, Loader2, RefreshCw, ShieldCheck } from "lucide-react";

export function PageLoading({ label = "Loading live workspace data…" }) {
  return (
    <div className="flex min-h-[360px] items-center justify-center" data-testid="live-loading">
      <div className="text-center">
        <Loader2 size={24} className="mx-auto animate-spin text-sm-accent" />
        <p className="mt-3 text-sm text-slate-500">{label}</p>
      </div>
    </div>
  );
}

export function PageError({ error, onRetry, title = "This workspace data is unavailable" }) {
  const reference = error?.requestId ? ` Reference ${error.requestId}.` : "";
  return (
    <div className="card-surface mx-auto mt-10 max-w-xl p-8 text-center" role="alert" data-testid="live-error">
      <AlertTriangle size={24} className="mx-auto text-[#D97706]" />
      <h2 className="font-display mt-4 text-lg font-bold text-sm-primary">{title}</h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-500">
        GrowthOS could not read this source right now. No demo data has been substituted.{reference}
      </p>
      {onRetry ? (
        <button onClick={() => onRetry().catch(() => undefined)} className="btn-outline mt-5 inline-flex items-center gap-2">
          <RefreshCw size={13} /> Try Again
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({ title, description, action = null, icon: Icon = Inbox }) {
  return (
    <div className="card-surface border-dashed p-8 text-center" data-testid="live-empty">
      <Icon size={24} className="mx-auto text-slate-400" />
      <h3 className="font-display mt-3 text-base font-bold text-sm-primary">{title}</h3>
      <p className="mx-auto mt-1.5 max-w-md text-sm leading-relaxed text-slate-500">{description}</p>
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}

export function InfoNote({ title, children, action = null, testId = "live-info" }) {
  return (
    <div className="rounded-xl border border-[#22C55E]/25 bg-[#22C55E]/[0.06] p-4" data-testid={testId}>
      <div className="flex items-start gap-3">
        <ShieldCheck size={16} className="mt-0.5 shrink-0 text-[#16A34A]" />
        <div className="min-w-0 flex-1">
          <div className="text-sm font-semibold text-sm-primary">{title}</div>
          {children ? <p className="mt-1 text-xs leading-relaxed text-slate-500">{children}</p> : null}
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    </div>
  );
}

export function UnavailablePanel({ title, description }) {
  return (
    <div className="rounded-xl border border-[#F59E0B]/25 bg-[#F59E0B]/[0.06] p-4" data-testid="live-unavailable">
      <div className="flex items-start gap-3">
        <AlertTriangle size={16} className="mt-0.5 shrink-0 text-[#D97706]" />
        <div>
          <div className="text-sm font-semibold text-sm-primary">{title}</div>
          <p className="mt-1 text-xs leading-relaxed text-slate-500">{description}</p>
        </div>
      </div>
    </div>
  );
}
